module.exports = {"Login":"Log In","Registration":"Sign Up","Invest Ideas":"Investment Ideas","Portfolio":"My Portfolio","How It Works":"How It Works","About UT Platform":"About UT Platform","IPO":"IPO","Pre-IPO":"Pre-IPO","OTC":"OTC","Stocks and ETF":"Stocks and ETF","Deposit":"Deposit","Withdraw":"Withdraw","My portfolio":"My portfolio","Free":"Free","Invested":"Invested","Current Profit":"Current Profit","All accounts":"All accounts"}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/header-microfrontend/locales/en/header.json
// module id = 1380
// module chunks = 118